import { DrawenObject } from "features/Context/types/DrawenObjectModel";
import { Point } from "features/LinearAlgebra/linearAlgebraModel";

export function getBearingPos(bearing: DrawenObject): Point {
  return [bearing.x, bearing.y];
}
